import CrudReducer from './crudReducer';

const cr = new CrudReducer('affiliation');

const reducer = cr.Reducer;

export default reducer;
